import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wba_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public files (thumbnails, PDFs, images) can be fetched without a token.
// Protected media (mp4/webm/pptx) requires the token — append it as query
// string since <video src> and <img src> can't send Authorization headers.
export const fileUrl = (fileId, { signed = false } = {}) => {
  const base = `${API}/files/${fileId}`;
  if (!signed) return base;
  const token = localStorage.getItem("wba_token");
  return token ? `${base}?token=${encodeURIComponent(token)}` : base;
};

export default api;
